module.exports = __webpack_public_path__ + "static/tanoto-sm-1d3c3eab9d022867b4c90efee485eb91.jpg";